export const ERROR_TYPES = Object.freeze({
  GENERIC_ERROR: '5000',
  PICK_UP_OUT_OF_RANGE: '40040',
  DROP_OFF_OUT_OF_RANGE: '40050',
  NO_LOANER_AVAILABLE: '40030',
  PICK_UP_INVALID_ADDRESS: '40060',
  DROP_OFF_INVALID_ADDRESS: '40070'
});

export const DROPOFF_PREFERENCE_OPTIONS = Object.freeze({
  SAME_AS_PICKUP_VALET: 'SAME_AS_PICKUP_VALET',
  CLUTCH_PARTIAL_VALET: 'CLUTCH_PARTIAL_VALET',
  ANOTHER_LOCATION_VALET: 'ANOTHER_LOCATION_VALET'
});



// WEBPACK FOOTER //
// ./src/constants/clutchValet.js